import { ThemeModeComponent } from '../assets/ts/layout';
import { useLayout } from '../layout/core';

export const toAbsoluteUrl = (pathname: string) =>
  import.meta.env.BASE_URL + pathname;

export const useIllustrationsPath = (illustrationName: string): string => {
  const { config } = useLayout();

  const extension = illustrationName.substring(
    illustrationName.lastIndexOf('.'),
    illustrationName.length
  );
  const illustration =
    ThemeModeComponent.getMode() === 'dark'
      ? `${illustrationName.substring(
          0,
          illustrationName.lastIndexOf('.')
        )}-dark`
      : illustrationName.substring(0, illustrationName.lastIndexOf('.'));
  return toAbsoluteUrl(
    `media/illustrations/${config.illustrations?.set}/${illustration}${extension}`
  );
};

export const toAbsoluteStatic = (pathname: string): string | undefined => {
  if (!pathname) return undefined;
  if (pathname.startsWith('http')) return pathname;
  return `${import.meta.env.VITE_APP_BACKEND_HOST}${pathname}`;
};
